import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AllItemTypesQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.ItemTypeFilter>;
  skip?: Types.InputMaybe<Types.Scalars['Int']>;
  take?: Types.InputMaybe<Types.Scalars['Int']>;
  price_for_store_id?: Types.InputMaybe<Types.Scalars['ID']>;
}>;


export type AllItemTypesQuery = { __typename?: 'Query', itemTypes: { __typename?: 'ItemTypesResult', total: number, items: Array<{ __typename?: 'ItemType', id: number, name: string, color_hex_code?: string | null, category: Types.ItemTypeCategory, billing_category?: Types.BillingCategory | null, epc_asset_id: number, image_url?: string | null, archived: boolean, weight: number, price?: number | null, billing_frequency?: Types.BillingFrequency | null, sku?: string | null, default_event_prices?: Array<{ __typename?: 'ItemTypeDefaultEventPrice', currency: Types.ItemTypeEventPriceCurrency, rental_price?: number | null, lost_price?: number | null, cleaning_price?: number | null }> | null, billomat_article_ids_by_country?: Array<{ __typename?: 'BillomatArticleIdByCountry', country_code: string, article_id: number }> | null, custom_field_definitions?: Array<{ __typename?: 'CustomFieldDefinition', id: string, name: string, type: Types.CustomFieldType, required?: boolean | null, default_value?: string | null, depends_on?: { __typename?: 'CustomFieldDependency', field_id: string, value: string } | null }> | null }> } };


export const AllItemTypesDocument = gql`
    query AllItemTypes($filter: ItemTypeFilter, $skip: Int, $take: Int, $price_for_store_id: ID) {
  itemTypes(
    filter: $filter
    skip: $skip
    take: $take
    price_for_store_id: $price_for_store_id
  ) {
    total
    items {
      id
      name
      color_hex_code
      category
      billing_category
      epc_asset_id
      image_url
      archived
      weight
      price
      billing_frequency
      sku
      default_event_prices {
        currency
        rental_price
        lost_price
        cleaning_price
      }
      billomat_article_ids_by_country {
        country_code
        article_id
      }
      custom_field_definitions {
        id
        name
        type
        required
        default_value
        depends_on {
          field_id
          value
        }
      }
    }
  }
}
    `;

/**
 * __useAllItemTypesQuery__
 *
 * To run a query within a React component, call `useAllItemTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllItemTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllItemTypesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      price_for_store_id: // value for 'price_for_store_id'
 *   },
 * });
 */
export function useAllItemTypesQuery(baseOptions?: Apollo.QueryHookOptions<AllItemTypesQuery, AllItemTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllItemTypesQuery, AllItemTypesQueryVariables>(AllItemTypesDocument, options);
      }
export function useAllItemTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllItemTypesQuery, AllItemTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllItemTypesQuery, AllItemTypesQueryVariables>(AllItemTypesDocument, options);
        }
export type AllItemTypesQueryHookResult = ReturnType<typeof useAllItemTypesQuery>;
export type AllItemTypesLazyQueryHookResult = ReturnType<typeof useAllItemTypesLazyQuery>;
export type AllItemTypesQueryResult = Apollo.QueryResult<AllItemTypesQuery, AllItemTypesQueryVariables>;